<script setup lang="ts">
import { useLanguage, Language } from "@/composable/useLanguage";
import { trackAppSetting } from "@/analytics/app-analytics";
import SettingsOptionRow from "./SettingsOptionRow.vue";

const { language, setLanguage } = useLanguage();

// Tracked here, not in setLanguage: the composable replays the stored
// language at boot, which is not a user action.
function onLanguagePicked(lng: Language) {
  trackAppSetting("language", lng);
  setLanguage(lng);
}

const options = [
  { label: "🇫🇷 Français", value: Language.FR },
  { label: "🇬🇧 English", value: Language.EN },
];
</script>

<template>
  <SettingsOptionRow
    :label="$t('dashboard:settings.language.title')"
    icon="bi-translate"
  >
    <el-select
      v-model="language"
      :placeholder="$t('dashboard:settings.language.placeholder')"
      style="width: 150px"
      @change="onLanguagePicked"
    >
      <el-option
        v-for="opt in options"
        :key="opt.value"
        :label="opt.label"
        :value="opt.value"
      />
    </el-select>
  </SettingsOptionRow>
</template>
